define('views/root/consumer/landing',[
	'backbone',
	'views/_base/baseview',
	'text!views/root/consumer/landing.html',
	'fancybox',
	'views/shared/video_iframe/video_iframe',
	'views/shared/list/icon_list',
	'views/shared/grid/grid',
	'views/shared/phone/phone_carousel',
	'views/root/pano',
	'views/root/join',
	'views/root/disclaimer',
	'views/shared/gpr/offer',
	'views/shared/registration/howitworks',
], function (
	Backbone,
	BaseView,
	Template,
	Fancybox,
	VideoIframe,
	IconListComponent,
	GridComponent,
	PhoneCarousel,
	PanoComponent,
	JoinComponent,
	DisclaimerComponent,
	GPROfferComponent,
	HowItWorksComponent
) {
	'use strict';

	return BaseView.extend({
		id: isSunsetting() ? 'sunset-landing' : 'landing',
		tagName: isSunsetting() ? 'div' : 'section',
		className: isSunsetting()
			? 'register-container'
			: 'fullWidth againstHeader againstFooter',
		template: _.template(Template),
		isRender: true,
		needsAuth: false,
		events: {
			'click #pano-video-btn': 'showVideo',
		},

		initialize: function (options) {
			options = options || {};

			this.email_guid = options.GUID;
			this.email_verification_code = options.VerificationCode;

			this.site_version = pf.getContent('version.id');

			// if(pf.fb_pixel && this.site_version == enums.siteVersion.bcbsaz){
			//     pf.fb_pixel.initializePixel();
			// }

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this, options);
		},

		render: function () {
			var phone = pf.getContent('landing.content.phone');

			this.$el.html(this.template());

			if (this.email_guid) {
				this.verifyEmailAddress();
			}

			// Add Pano
			this.addPano();

			var site_versions_gpr = [
				enums.siteVersion.bcbssc,
				enums.siteVersion.rxsavings,
				enums.siteVersion.proteus,
				enums.siteVersion.bcbsal,
				enums.siteVersion.alahealth,
				enums.siteVersion.csnp,
				enums.siteVersion.centene,
				enums.siteVersion.bcbskc,
				enums.siteVersion.almyblue,
			];

			if (site_versions_gpr.includes(this.site_version)) {
				// temporarily disable if centene OR bcbskc ONLY

				if (
					this.site_version !== enums.siteVersion.centene ||
					this.site_version !== enums.siteVersion.bcbskc
				) {
					// Add GPR Offer
					this.addGPROffer();
				}
			} else {
				// Add How Payment Works
				this.addHowPaymentWorks();

				// Add Merchant Logos
				this.addMerchantLogos();

				// Add How It Works
				this.addHowItWorks();

				// Add Join For Free Ad
				this.addJoinAd();
			}

			if (phone && phone.enabled) {
				// Add Phone Carousel
				this.addPhoneCarousel();
			}

			// disable if centene OR  bcbskc ONLY
			if (
				this.site_version !== enums.siteVersion.centene ||
				this.site_version !== enums.siteVersion.bcbskc
			) {
				// Add Disclaimers
				this.addDisclaimers();
			}

			// Add Partner specific classes
			if (
				this.site_version == enums.siteVersion.bcbsla ||
				this.site_version == enums.siteVersion.bcbsal
			) {
				this.addSpecialHeaderCls();
			}

			return this;
		},

		verifyEmailAddress: function () {
			var data = null,
				success = false,
				that = this;

			$.ajax({
				type: 'GET',
				url: pf.url + '/EmailVerification',
				data: {
					EmailGUID: this.email_guid,
					VerificationCode: this.email_verification_code,
				},
				async: false,
				contentType: 'application/json',
				success: function (response) {
					success = true;
					that.ResponseType = 'S';
					that.emailConfirmationView();
				},
				error: function (response) {
					that.ResponseType = 'F';
				},
			});
		},

		emailConfirmationView: function () {
			pfdialog.alert({
				Title: 'Email Verified',
				Body: 'Thank you for confirming your email address',
				okCallback: function () {
					pf.navigate('');
				},
			});
		},

		showVideo: function () {
			var video_url = pf.getContent('landing.content.pano.video.url');

			this.videoView = new VideoIframe({
				videoID: video_url,
				autoPlay: true,
			});

			$.fancybox(this.videoView.el, {
				closeBtn: true,
				scrolling: 'no',
			});
		},

		calcVideoWidth: function () {
			return $(window).width() - 40;
		},

		calcVideoHeight: function () {
			var width = this.calcVideoWidth();
			return width / (16 / 9);
		},

		addPano: function () {
			var pano = new PanoComponent({ elementName: '.js-pano-container' });
		},

		addGPROffer: function () {
			var gpr_offer = new GPROfferComponent({
				elementName: '.js-gpr-offer-container',
			});
		},

		addMerchantLogos: function () {
			var logos = pf.getContent('landing.content.logos'),
				icon_list = new IconListComponent({
					elementName: '.js-merchant-icon-container',
					icons: logos,
				});

			this.$el.find('.js-merchant-icon-container').css({ opacity: 1 });
		},

		createAccountExceptions: function () {
			$('#header-inner-container .user-links').hide();
			$('#landing .pano').addClass('create-password-container');
			$('#landing .joinforfree').hide();
			$('#pf-logo').on('click', function () {
				window.location.href = '';
			});
		},

		addSpecialHeaderCls: function () {
			$('#header-logged-out').addClass('header-gradient');
			$('#header-logged-out').addClass('link-colors-dark');
		},

		addPhoneCarousel: function () {
			var phone_items = pf.getContent('landing.content.phone.items'),
				phone_carousel = new PhoneCarousel({
					elementName: '.js-phone-carousel',
					items: phone_items,
				});
		},

		addHowItWorks: function () {
			var how_it_works = new GridComponent({
				elementName: '.js-how-it-works',
				grid: pf.getContent('landing.content.grid'),
			});
		},

		addJoinAd: function () {
			var join_ad = new JoinComponent({ elementName: '.js-join-container' });
		},

		addDisclaimers: function () {
			var disclaimers = new DisclaimerComponent({
				elementName: '.js-disclaimer-container',
			});
		},

		addHowPaymentWorks: function () {
			if (this.site_version == enums.siteVersion.payforward) {
				// var how_payment_it_works = new HowItWorksComponent({ elementName: '.js-how-payment-works-container' });
			}
		},

		close: function () {
			if (this.videoView) {
				this.cleanup(this.videoView);
			}
		},
	});
});

